import { ReactNode } from 'react';
import { Spinner } from 'app/components';
import { i18n } from 'shared/i18n';

interface Loader {
  isLoading: boolean;
  isSuccess: boolean;
  isError?: boolean;
}

export function wrapper(title: ReactNode, loaders: Loader[], content: () => ReactNode, footer: () => ReactNode, notice: ReactNode = null) {
  const isError = loaders.some((loader) => loader.isError);
  const isLoading = loaders.some((loader) => loader.isLoading);
  const isSuccess = loaders.every((loader) => loader.isSuccess);

  const body = isError ? <p className="text-danger">{i18n('reference-data:failed-parsing-xlsx')}</p> : isLoading || !isSuccess ? <Spinner /> : content();

  return (
    <>
      <div className="header d-flex">
        <h3>{title}</h3>
      </div>
      <div className="body overflow-auto">
        {notice}
        {body}
      </div>
      <div className="px-r-1-25 py-r-0-75">{footer()}</div>
    </>
  );
}
